// components
import { styled, Box, BoxProps } from '@mui/material';

export const StyledRelativeBox = styled(Box)(() => ({
  position: 'relative'
}));

export const StyledBoxFlex = styled(Box)(() => ({
  display: 'flex'
}));

export const StyledFlexGrowBox = styled(Box)(() => ({
  flexGrow: 1
}));

export const StyledBoxFlexWrapStart = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  flexWrap: 'wrap'
}));

export const StyledBoxFlexStartSmallGap = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: theme.spacing(1)
}));

export const StyledBoxFlexWrapEnd = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  flexWrap: 'wrap'
}));

export const StyledBoxFlexAlignCenter = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center'
}));

export const StyledBoxFlexAlignCenterSpaceBetween = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCompact'
})<BoxProps & { isCompact?: boolean }>(({ isCompact = false }) => ({
  display: 'flex',
  alignItems: isCompact ? 'flex-start' : 'center',
  justifyContent: 'space-between'
}));

export const StyledBoxFlexColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4)
}));

export const StyledBoxFlexColumnNoGap = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const StyledBoxFlexSmallGap = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));

export const StyledBoxFlexColumnSmallGap = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

export const StyledBoxFlexColumnSmallGapCenter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  alignItems: 'center'
}));

export const StyledBoxFlexColumnLargeGap = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8)
}));

export const StyledBoxFlexRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4)
}));

export const StyledBoxFlexCenter = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center'
}));

export const StyledBoxFlexStretch = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'stretch'
}));

export const StyledBoxFlexCenterWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  flexWrap: 'wrap'
}));

export const StyledBoxHalfWidth = styled(Box)(() => ({
  width: '50%'
}));

export const StyledTableBoxWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2.5)
}));

export const StyledBoxDefaultXPadding = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 4)
}));

export const StyledBoxAutoMarginLeft = styled(Box)(() => ({
  display: 'flex',
  marginLeft: 'auto'
}));

export const StyledBoxFlexCenterSpaceBetween = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const StyledBoxFlexCenterGap = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2)
}));

export const StyledBoxFlexAlignStart = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start'
}));

export const StyledBoxFlexJustifyCenter = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center'
}));

export const StyledBoxFlexJustifyEnd = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end'
}));

export const StyledBoxFlexJustifyEndGap = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2)
}));

export const StyledBoxFlexColumnJustifyCenterFullWidth = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%'
}));

export const StyledBoxFlexJustifyFullWidth = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: '100%'
}));

export const StyledBoxFlexCenterSmallGap = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center'
}));

export const StyledBoxFlexColumnCenterSmallGap = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  alignItems: 'end'
}));

export const StyledBoxFlexColumnSpaceBetweenFullHeight = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%'
}));

export const StyledBoxFlexCenterGapFullWidth = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  width: '100%'
}));

export const StyledBoxFlexCenterSmallGapFullWidth = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    width: '100%'
  })
);

export const StyledBoxFullWidth = styled(Box)(() => ({
  width: '100%'
}));

export const StyledBoxFlexCenterWrapFullWidth = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  flexWrap: 'wrap',
  width: '100%'
}));

export const StyledBoxFlexColumnSmallGapHalfWidth = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '50%'
  })
);

export const StyledBoxCenterExtraSmallGap = styled(Box)<BoxProps>(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  })
);
